import React from "react";
import { Button } from "react-bootstrap";
import { Search, ArrowRepeat, FileExcel, FiletypeCsv } from "react-bootstrap-icons";

export const ButtonSearch = ({ onClick }) => {
    return (
        <Button
            type="button"
            variant="primary"
            className='btn-sr'
            onClick={() => onClick()}
            title="Search">
            <Search />
        </Button>
    )
}

export const ButtonReset = ({ onClick }) => {
    return (
        <Button
            type="button"
            variant="secondary"
            className='btn-sr ms-1'
            onClick={() => onClick()}
            title="Reset">
            <ArrowRepeat size={18} />
        </Button>
    )
}

export const ButtonExportExcel = ({ onClick }) => {
    return (
        <Button
            size="sm"
            type="button"
            variant="info"
            className='ms-1 btn-export'
            onClick={() => onClick()}
            title="Export to CSV">
            <FileExcel size={15} />
        </Button>
    )
}

export const ButtonExportCsv = ({ onClick }) => {
    return (
        <Button
            size="sm"
            type="button"
            variant="info"
            className='ms-1 btn-export'
            onClick={() => onClick()}
            title="Export to CSV">
            <FiletypeCsv size={15} />
        </Button>
    )
}
